module.exports = function _arrayFromIterator(iter) {
  var list = [];
  var next;
  while (!(next = iter.next()).done) {
    list.push(next.value);
  }
  return list;
};



//////////////////
// WEBPACK FOOTER
// /Users/cully/projects/Jobs/abound/~/ramda/src/internal/_arrayFromIterator.js
// module id = ../../node_modules/ramda/src/internal/_arrayFromIterator.js
// module chunks = 18